import {AxiosResponse} from "axios";

export const checkDocument = () => {
    return typeof window !== "undefined" || typeof document !== "undefined"
}

//Проверка на мобильное устройство
export const isMobile = (maxSize = 768) => {
    if(!checkDocument()) return;

    return window.innerWidth <= maxSize
};

export const scrollTop = () => {
    if(!checkDocument()) return;

    window.scrollTo({top: 0, behavior: 'smooth'})
}

//Скачивание файла из response
export const downloadResponseFile = (response: AxiosResponse) => {
    if(!checkDocument()) return;

    // Попытка получить имя файла из заголовков ответа
    const contentDisposition = response.headers['content-disposition'];
    // Имя файла по умолчанию
    let fileName = 'invoice_stat_resume.xlsx';

    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length > 1) {
            fileName = decodeURIComponent(fileNameMatch[1]);
        }
    }

    const blob = new Blob([response.data], {type: response.data.type});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

// Безопасные обёртки над localStorage (на случай SSR/приватного режима)
const canUseLocalStorage = () => {
    try {
        if (typeof window === "undefined" || !window.localStorage) return false;
        const k = "__ls_test__";
        window.localStorage.setItem(k, "1");
        window.localStorage.removeItem(k);
        return true;
    } catch {
        return false;
    }
};

export const setLocalStorage = (name: any, value: any, timeInMin: any) => {
    if (!canUseLocalStorage()) return;

    const expiresAt = typeof timeInMin === "number" && timeInMin > 0
        ? Date.now() + timeInMin * 60 * 1000
        : null;

    const payload = JSON.stringify({
        v: value,
        exp: expiresAt, // timestamp в мс или null (бессрочно)
    });

    window.localStorage.setItem(String(name), payload);
}

export const getLocalStorage = (name: String) => {
    if (!canUseLocalStorage()) return null;

    const raw = window.localStorage.getItem(String(name));
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw) as { v: any; exp: number | null };
        if (parsed && (parsed.exp === null || parsed.exp > Date.now())) {
            return parsed.v;
        }
        // истёк срок — подчистим
        window.localStorage.removeItem(String(name));
        return null;
    } catch {
        // повреждённые данные — подчистим
        window.localStorage.removeItem(String(name));
        return null;
    }
}

export const setCookie = (name: any, value: any, timeInMin: any) => {
    if(!checkDocument()) return;

    let expires = "";
    if (timeInMin) {
        const date = new Date();
        date.setTime(date.getTime() + timeInMin * 60 * 1000); // 24 hours
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const getCookie = (name: String) => {
    if(!checkDocument()) return;

    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export const copyText = (text: string) => {
    if(!checkDocument()) return;

    var textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    textField.focus();
    document.execCommand('copy');
    textField.remove();
}

export const numberCommaFormat = (number: any) => {
    if (isNaN(number)) return '0';

    return number
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .replace(/-,/, '-');
}

export const formatPhone = (phone: any) => {
    if (!phone) return "";
    return phone.replace(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/, "+7 ($1) $2-$3-$4");
}

